import React, { useContext } from 'react'
import { Table } from 'components/table-refactored/table'
import { useTableInstance } from 'components/table-refactored/table-context'
import { TicketEditContext } from 'pages/ticket-edit'

export const TicketInlineTableContainer: React.FC<any> = props => {
  const tableInstance = useTableInstance()
  const { setSelectedTicketId } = useContext(TicketEditContext)
 
  
  React.useEffect(() => {
    if (props.selectedRow > -1 && props.selectedRow !== null) {
      tableInstance.getRowModel().rows[props.selectedRow].toggleSelected()
    }
  }, [props.selectedRow])
  const onRowClick = (row, unfilteredRow) => {
    
    tableInstance.toggleAllRowsSelected(false);

    if ( unfilteredRow.getIsSelected() ) {
        setSelectedTicketId(null);
    } else {
        props.onRowClick(row)
    }
    unfilteredRow?.toggleSelected();
    
  }
  return (
      <Table
        onRowClick={onRowClick}
        isLoading={props.isLoading}
        isEmpty={props.isEmpty}
      />
  )
}
